"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require('@angular/core');
var cache_storage_abstract_service_1 = require('../cache-storage-abstract.service');
/**
 * Service for storing data in local storage
 */
var CacheMemoryStorage = (function (_super) {
    __extends(CacheMemoryStorage, _super);
    function CacheMemoryStorage() {
        _super.apply(this, arguments);
        this._data = {};
    }
    CacheMemoryStorage.prototype.getItem = function (key) {
        return this._data[key] ? this._data[key] : null;
    };
    CacheMemoryStorage.prototype.setItem = function (key, value) {
        this._data[key] = value;
        return true;
    };
    CacheMemoryStorage.prototype.removeItem = function (key) {
        delete this._data[key];
    };
    CacheMemoryStorage.prototype.clear = function () {
        this._data = [];
    };
    CacheMemoryStorage.prototype.type = function () {
        return 2 /* MEMORY */;
    };
    CacheMemoryStorage.prototype.isEnabled = function () {
        return true;
    };
    CacheMemoryStorage = __decorate([
        core_1.Injectable(), 
        __metadata('design:paramtypes', [])
    ], CacheMemoryStorage);
    return CacheMemoryStorage;
}(cache_storage_abstract_service_1.CacheStorageAbstract));
exports.CacheMemoryStorage = CacheMemoryStorage;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-cache-service/dist/src/services/storage/memory/cache-memory.service.js
// module id = 1038
// module chunks = 3